// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-games-development-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-games-development-section .slot-games-development-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .cards-grid {
  --cards-grid-number: 3;
  --cards-grid-gap: 3.75rem;
  display: grid;
  grid-template-columns: repeat(var(--cards-grid-number), 1fr);
  gap: var(--cards-grid-gap);
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card {
  width: 100%;
  height: 100%;
  background-color: var(--secondaryMain-1000);
  border: 1px solid var(--black-200);
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 2.25rem;
  padding: 2.25rem 2rem;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card:nth-child(odd) {
  background-color: var(--white-1000);
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.5rem;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .icon-box {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .icon-box img {
  width: 100%;
  min-width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .title-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-body {
  width: 100%;
  flex-grow: 1;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-body .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.slot-games-development-section .slot-games-development-wrap .slot-games-development-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .slot-games-development-section {
    padding: 2.5rem 0;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .cards-grid {
    --cards-grid-number: 3;
    --cards-grid-gap: 1.25rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card {
    border-radius: 0.75rem;
    gap: 1.75rem;
    padding: 1.75rem 1.5rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .icon-box {
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .title-text {
    font-size: 1rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-body .para-text {
    font-size: 1rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-games-development-section {
    padding: 2rem 0;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card {
    border-radius: 0.75rem;
    gap: 1.25rem;
    padding: 1.25rem 1rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header {
    gap: 1rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .icon-box {
    width: 2.25rem;
    min-width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.25rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-header .title-text {
    font-size: 0.875rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .card .card-body .para-text {
    font-size: 0.875rem;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 474.98px) {
  .slot-games-development-section {
    padding: 2rem 0;
  }
  .slot-games-development-section .slot-games-development-wrap .slot-games-development-box .cards-grid {
    --cards-grid-number: 1;
    --cards-grid-gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SlotGamesDevelopmentSection/SlotGamesDevelopmentStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,4DAAA;EACA,0BAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;AADR;AAGQ;EACE,mCAAA;AADV;AAIQ;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AAFV;AAIU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFZ;AAIY;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAFd;AAMU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAJZ;AAQQ;EACE,WAAA;EACA,YAAA;AANV;AAQU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AANZ;AAWM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AATR;AAcE;EAtFF;IAuFI,iBAAA;EAXF;EAeM;IACE,sBAAA;IACA,yBAAA;EAbR;EAgBM;IACE,sBAAA;IACA,YAAA;IACA,uBAAA;EAdR;EAiBU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EAfZ;EAkBU;IACE,eAAA;EAhBZ;EAqBU;IACE,eAAA;EAnBZ;EAwBM;IACE,kBAAA;EAtBR;AACF;AA2BE;EA/HF;IAgII,eAAA;EAxBF;EA4BM;IACE,sBAAA;IACA,sBAAA;EA1BR;EA6BM;IACE,sBAAA;IACA,YAAA;IACA,qBAAA;EA3BR;EA6BQ;IACE,SAAA;EA3BV;EA6BU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;IACA,sBAAA;EA3BZ;EA8BU;IACE,mBAAA;EA5BZ;EAiCU;IACE,mBAAA;EA/BZ;EAoCM;IACE,mBAAA;EAlCR;AACF;AAuCE;EA3KF;IA4KI,eAAA;EApCF;EAwCM;IACE,sBAAA;IACA,sBAAA;EAtCR;AACF","sourcesContent":[".slot-games-development-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .slot-games-development-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .slot-games-development-box {\n      .cards-grid {\n        --cards-grid-number: 3;\n        --cards-grid-gap: 3.75rem;\n        display: grid;\n        grid-template-columns: repeat(var(--cards-grid-number), 1fr);\n        gap: var(--cards-grid-gap);\n      }\n\n      .card {\n        width: 100%;\n        height: 100%;\n        background-color: var(--secondaryMain-1000);\n        border: 1px solid var(--black-200);\n        border-radius: 0.75rem;\n        display: flex;\n        flex-direction: column;\n        gap: 2.25rem;\n        padding: 2.25rem 2rem;\n\n        &:nth-child(odd) {\n          background-color: var(--white-1000);\n        }\n      \n        .card-header {\n          width: 100%;\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 1.5rem;\n\n          .icon-box {\n            width: 4rem;\n            min-width: 4rem;\n            height: 4rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            img {\n              width: 100%;\n              min-width: 100%;\n              height: 100%;\n              object-fit: contain;\n              object-position: center;\n            }\n          }\n\n          .title-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 600;\n            line-height: 1.4;\n          }\n        }\n\n        .card-body {\n          width: 100%;\n          flex-grow: 1;\n\n          .para-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 400;\n            line-height: 1.4;\n          }\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .slot-games-development-wrap {  \n      .slot-games-development-box {\n        .cards-grid {\n          --cards-grid-number: 3;\n          --cards-grid-gap: 1.25rem;\n        }\n  \n        .card {\n          border-radius: 0.75rem;\n          gap: 1.75rem;\n          padding: 1.75rem 1.5rem;\n        \n          .card-header {\n            .icon-box {\n              width: 2.75rem;\n              min-width: 2.75rem;\n              height: 2.75rem;\n            }\n  \n            .title-text {\n              font-size: 1rem;\n            }\n          }\n  \n          .card-body {  \n            .para-text {\n              font-size: 1rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .slot-games-development-wrap {  \n      .slot-games-development-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n  \n        .card {     \n          border-radius: 0.75rem;\n          gap: 1.25rem;\n          padding: 1.25rem 1rem;\n\n          .card-header { \n            gap: 1rem;\n            \n            .icon-box {\n              width: 2.25rem;\n              min-width: 2.25rem;\n              height: 2.25rem;\n              border-radius: 0.25rem;\n            }\n\n            .title-text {\n              font-size: 0.875rem;\n            }\n          }\n  \n          .card-body {  \n            .para-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 2rem 0;\n\n    .slot-games-development-wrap {  \n      .slot-games-development-box {\n        .cards-grid {\n          --cards-grid-number: 1;\n          --cards-grid-gap: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
